import { selectFavorites } from "store/favorites/selectors";
import { useSelector } from "react-redux";
import { SpacesList } from "views/SpacesListPage/components";

import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import { SpaceCard } from "reusableComponents";

const FavoritesPage = ({ forDashboard = false }) => {
  const favorites = useSelector(selectFavorites);
  const { t } = useTranslation("global");

  if (favorites.length === 0 || !favorites) {
    return (
      <div className={`${styles.noResultsSection} pageContainer`}>
        <div className={styles.breadcrumb}>
          <a href="/">{t("home.title")} /</a>
          <p>{t("dashboard.seeker.favorites")}</p>
        </div>
        <h1 className={styles.noResultsTitle}>{t("search.noResultTitle")}</h1>
        <p
          className={styles.noResultsText}
          dangerouslySetInnerHTML={{ __html: t("basket.noResultText") }}
        ></p>
      </div>
    );
  }
  return (
    <div className="pageContainer">
      <div className={styles.favoritesPage}>
        <div className={styles.breadcrumb}>
          <a href="/">{t("home.title")} /</a>
          <p>{t("dashboard.seeker.favorites")}</p>
        </div>
        {forDashboard ? (
          <div className={styles.favoritesList}>
            {favorites.map((favorite) => (
              <SpaceCard place={favorite} />
            ))}
          </div>
        ) : (
          <SpacesList spaces={favorites} />
        )}
      </div>
    </div>
  );
};

export default FavoritesPage;
